var map = {
	"./account/accountedit.vue": [
		2457,
		8362,
		2457
	],
	"./account/accountview.vue": [
		4744,
		8362,
		2457,
		4744
	],
	"./account/changepassword.vue": [
		385,
		8362,
		385
	],
	"./bloodtype/add.vue": [
		8104,
		8362,
		8104
	],
	"./bloodtype/edit.vue": [
		1231,
		8362,
		1231
	],
	"./bloodtype/list.vue": [
		6148,
		3789,
		6148
	],
	"./bloodtype/view.vue": [
		2662,
		2662
	],
	"./errors/forbidden.vue": [
		1256,
		1256
	],
	"./errors/pagenotfound.vue": [
		1763,
		1763
	],
	"./grade/add.vue": [
		1574,
		8362,
		1574
	],
	"./grade/edit.vue": [
		2292,
		8362,
		2292
	],
	"./grade/list.vue": [
		7390,
		3789,
		7390
	],
	"./grade/view.vue": [
		8315,
		8315
	],
	"./groups/add.vue": [
		1165,
		8362,
		1165
	],
	"./groups/edit.vue": [
		2012,
		8362,
		2012
	],
	"./groups/list.vue": [
		5398,
		3789,
		5398
	],
	"./groups/view.vue": [
		9986,
		9986
	],
	"./home/home.vue": [
		7761,
		7761
	],
	"./index/accountblocked.vue": [
		837,
		837
	],
	"./index/accountcreated.vue": [
		7163,
		7163
	],
	"./index/accountpending.vue": [
		9482,
		9482
	],
	"./index/emailverified.vue": [
		2115,
		2115
	],
	"./index/forgotpassword.vue": [
		1097,
		1097
	],
	"./index/index.vue": [
		9330,
		9330
	],
	"./index/resetpassword.vue": [
		1475,
		8362,
		1475
	],
	"./index/resetpassword_completed.vue": [
		2057,
		2057
	],
	"./index/userregister.vue": [
		6074,
		8362,
		6074
	],
	"./index/verifyemail.vue": [
		8927,
		8927
	],
	"./index/verifyotp.vue": [
		8181,
		8181
	],
	"./parents/add.vue": [
		2197,
		8362,
		2197
	],
	"./parents/edit.vue": [
		8186,
		8362,
		8186
	],
	"./parents/list.vue": [
		7632,
		3789,
		7632
	],
	"./parents/view.vue": [
		6963,
		6963
	],
	"./permissions/add.vue": [
		6103,
		8362,
		6103
	],
	"./permissions/edit.vue": [
		9409,
		8362,
		9409
	],
	"./permissions/list.vue": [
		2475,
		3789,
		2475
	],
	"./permissions/view.vue": [
		7978,
		7978
	],
	"./professors/add.vue": [
		3506,
		8362,
		3506
	],
	"./professors/components/CameraComponent.vue": [
		1852,
		1852
	],
	"./professors/edit.vue": [
		525,
		8362,
		525
	],
	"./professors/list.vue": [
		4310,
		3789,
		4310
	],
	"./professors/view.vue": [
		6603,
		6603
	],
	"./roles/add.vue": [
		141,
		8362,
		141
	],
	"./roles/detail-pages.vue": [
		8765,
		3789,
		8765
	],
	"./roles/edit.vue": [
		7996,
		8362,
		7996
	],
	"./roles/list.vue": [
		2530,
		3789,
		2530
	],
	"./roles/view.vue": [
		4213,
		4213
	],
	"./students/add.vue": [
		1777,
		8362,
		1777
	],
	"./students/components/CameraComponent.vue": [
		4071,
		4071
	],
	"./students/edit.vue": [
		1468,
		8362,
		1468
	],
	"./students/list.vue": [
		3656,
		3789,
		3656
	],
	"./students/view.vue": [
		7564,
		7564
	],
	"./users/add.vue": [
		664,
		8362,
		664
	],
	"./users/edit.vue": [
		7961,
		8362,
		7961
	],
	"./users/list.vue": [
		1838,
		3789,
		1838
	],
	"./users/view.vue": [
		4910,
		4910
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2385;
module.exports = webpackAsyncContext;